import { useCallback, useState } from 'react';
import { useScrollDetection } from '../../../hooks';

const useMenuScroll = () => {
  const [menuRef, setMenuRef] = useState(null);
  const scrollState = useScrollDetection(menuRef, {
    direction: 'vertical',
  });

  const toggleMenuOpen = useCallback((isMenuOpen) => {
    setMenuRef(
      isMenuOpen
        ? {
            current: document.querySelector('.new-search-experience .rbt-menu'),
          }
        : null
    );
  }, []);

  return [toggleMenuOpen, scrollState];
};

export default useMenuScroll;
